<template>
  <div>
    <div class="header">
      <h1 class="page-title">申请列表</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <ul class="menuItems clearfix">
          <li @click="Allorder()">
            <a>全部订单</a>
            <span class="num" v-show="num.all">{{num.all}}</span>
          </li>
          <li @click="queryorder(0)">
            <a>申请中</a>
            <span class="num" v-show="num[0]">{{num[0]}}</span>
          </li>
          <li @click="queryorder(1)">
            <a>已批准</a>
            <span class="num" v-show="num[1]">{{num[1]}}</span>
          </li>
          <li @click="queryorder(2)">
            <a>已驳回</a>
            <span class="num" v-show="num[2]">{{num[2]}}</span>
          </li>
          <li @click="queryorder(3)">
            <a>已替换</a>
            <span class="num" v-show="num[2]">{{num[3]}}</span>
          </li>
        </ul>
        <div class="block">
          <span>下单日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectOrder()">搜索</button>
          <!-- <div class="sy-zongj">
            <i>总计</i>
            <span>
              总订单数:
              <b>{{countOrder}}</b>条
            </span>
            <span>
              总金额:
              <b>{{countMoney}}</b>元
            </span>
          </div>-->
        </div>
      </div>

      <div class="main">
        <el-table
          v-loading="loading"
          :data="orderListData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            :resizable="false"
            type="index"
            :index="indexMethod"
            width="50"
            label="序 号"
          ></el-table-column>
          <el-table-column width="145" :resizable="false" prop="order_id" label="订单号"></el-table-column>
          <el-table-column width="90" :resizable="false" prop="product_name" label="产品名称"></el-table-column>
          <el-table-column width="230" :resizable="false" prop="title" label="规格"></el-table-column>
          <el-table-column width="130" :resizable="false" prop="file" label="文件名"></el-table-column>
          <el-table-column width="90" :resizable="false" prop="goods_price" label="产品金额(元)"></el-table-column>
          <el-table-column width="90" :resizable="false" prop="shipping_fee" label="运费(元)"></el-table-column>
          <el-table-column width="110" :resizable="false" prop="total_price" label="总金额(元)"></el-table-column>
          <el-table-column width="80" :resizable="false" prop="order_status_str" label="订单状态"></el-table-column>
          <el-table-column width="80" :resizable="false" prop="express_name" label="物流方式"></el-table-column>
          <el-table-column width="80" :resizable="false" label="申请状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.file_status_str=='已批准'">{{scope.row.file_status_str}}</el-tag>
              <el-tag
                type="warning"
                v-else-if="scope.row.file_status_str=='申请中'"
              >{{scope.row.file_status_str}}</el-tag>
              <el-tag type="danger" v-else>{{scope.row.file_status_str}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="150" :resizable="false" prop="bhquery" label="回复"></el-table-column>
          <el-table-column width="140" :resizable="false" label="申请时间">
            <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
          </el-table-column>
          <el-table-column width="140" :resizable="false" label="操作">
            <template slot-scope="scope">
              <div class="f" v-if="scope.row.file_status_str=='已批准'">
                <form name="theform">
                  <input style="display:none" type="radio" name="myradio" value="local_name" />
                  <input
                    style="display:none"
                    type="radio"
                    name="myradio"
                    value="random_name"
                    checked="true"
                  />
                  <input style="display:none" type="text" id="dirname" :value="filePath" size="50" />
                </form>
                <div :id="scope.row.orderid" class="contaniner">
                  <a id="selectfiles" href="javascript:void(0);" class="cz xq">更换文件</a>
                </div>
                <div class="ossfile"></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="pageCount"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </el-card>
    <div class="message">
      <p>列表默认显示当天，你可通过时间搜索</p>
    </div>
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel'

import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'

let thatt = ''
let f = false
let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  // len = len || 32;
  // var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  // var maxPos = chars.length;
  // var pwd = '';
  // for (i = 0; i < len; i++) {
  //     pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  // }

  // $(window.Fname)
  //   .parents('.title')
  //   .siblings('.shangpin-info')
  //   .find('.left p')
  //   .text() +
  // '-' +

  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}
function upit(index, el) {
  let uploader = new plupload.Uploader({
    id: index,
    runtimes: 'html5,flash,silverlight,html4',
    browse_button: el,
    // multi_selection: false,
    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
    // chunk_size: 1024 * 1024 * 5, 是否分片上传
    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
    url: 'http://oss.aliyuncs.com',
    filters: {
      mime_types: [
        // 限制可上传的文件格式
        { title: 'Image files', extensions: 'jpg' },
        { title: 'Zip files', extensions: 'zip' },
        { title: 'Rar files', extensions: 'rar' },
        { title: 'Cdr files', extensions: 'cdr' }
      ]
    },
    init: {
      PostInit: function() {
        $('.ossfile')
          .eq(index)
          .text('')
      },

      FilesAdded: function(up, files) {
        $('.ossfile')
          .eq(index)
          .show()
        window.Fname = $(el)
          .parents('.f')
          .siblings('.title')
          .find('.check')[0]
        set_upload_param(uploader, '', false)
        plupload.each(files, function(file) {
          let ossFile = $(el)
            .parents('.contaniner')
            .siblings('.ossfile')
          ossFile.html(
            '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>' +
              '</div>'
          )
        })
      },

      BeforeUpload: function(up, file) {
        check_object_radio()
        get_dirname()
        set_upload_param(up, file.name, true)
      },

      UploadProgress: function(up, file) {
        var d = document.getElementById(file.id)
        d.getElementsByTagName('b')[0].innerHTML =
          '<span>' + file.percent + '%</span>'
        var prog = d.getElementsByTagName('div')[0]
        var progBar = prog.getElementsByTagName('div')[0]
        progBar.style.width = 2.9 * file.percent + 'px'
        progBar.setAttribute('aria-valuenow', file.percent)
      },

      FileUploaded: function(up, file, info) {
        if (info.status == 200) {
          let order_id = $(el)
            .parents('.contaniner')
            .attr('id')
          let filenamee =
            'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)

          $.ajax({
            type: 'post',
            url: url + '/api/order/replacefile',
            data: {
              id: order_id,
              filename: filenamee,
              file: file.name,
              token: window.localStorage.getItem('token')
            },
            dataType: 'json',
            success: function(res) {
              if (res.code == 1) {
                $(el)
                  .parent('.contaniner')
                  .siblings('.ossfile')
                  .hide()
                f = true
                thatt.$confirm('更换文件成功!', '提示')
                thatt.queryOrderList()
              } else {
                alert('上传失败1111')
              }
            }
          })
        } else {
          alert('上传出错了')
        }
      },

      Error: function(up, err) {
        alert('出错了！')
        window.location.reload()
      }
    }
  })

  uploader.init()
}

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: null,
      //   订单状态列表
      orderStatusList: [],
      orderListData: [],
      token: window.localStorage.getItem('token'),
      page: 1,
      keywords: '',
      loading: true,
      pageCount: 1,
      status: '',
      mindate: '',
      maxdate: '',
      countOrder: 0,
      countMoney: 0,
      filePath: '',
      num: {},
      flag: false
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryOrderList()
    let u = JSON.parse(window.localStorage.getItem('u'))
    this.filePath =
      'uploads/' +
      u.mobile +
      '/' +
      new Date().toLocaleDateString().replace(/\//g, '-')
    this.getYue()
  },
  mounted() {
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
      $(this)
        .siblings('li')
        .children('a')
        .css({ color: '#666', 'border-left': '3px solid #ccc' })
    })
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    Allorder() {
      this.status = ''
      this.keywords = ''
      this.page = 1
      if (this.value2 === null || !this.value2) {
        this.mindate = ''
        this.maxdate = ''
      }
      this.queryOrderList()
    },
    queryorder(status) {
      if (status == 0 && (this.value2 === null || !this.value2)) {
        this.mindate = ''
        this.maxdate = ''
      } else if (this.value2 === null || !this.value2) {
        this.mindate =
          new Date().toLocaleDateString().replace(/\//g, '-') + ' 00:00:00'
        this.maxdate =
          new Date().toLocaleDateString().replace(/\//g, '-') + ' 23:59:59'
      }
      this.status = status
      this.queryOrderList()
    },
    selectOrder() {
      this.queryOrderList()
    },
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    handleCurrentChange(val) {
      this.page = val
      this.queryOrderList()
    },
    //   订单列表
    async queryOrderList() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('status', this.status)
      param.append('keywords', this.keywords)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/fileslst',
        data: param
      })

      this.loading = false
      if (res.code == 1) {
        this.orderListData = res.data.data
        this.pageCount = res.data.page_count * 10
        this.num = res.data.data_count
        thatt = this
        // 初始化
        this.$nextTick(_ => {
          if (f == false) {
            setTimeout(() => {
              $.each($('.f #selectfiles'), function(
                indexInArray,
                valueOfElement
              ) {
                upit(indexInArray, valueOfElement)
              })
            }, 500)
          }
        })
        if (res.data.num_count) {
          this.countOrder = res.data.num_count
          this.countMoney = res.data.price_count.toFixed(2)
        } else {
          this.countOrder = 0
          this.countMoney = 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      position: relative;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
      .num {
        display: block;
        background: red;
        border-radius: 50%;
        position: absolute;
        top: -4px;
        right: -3px;
        transform: scale(0.9);
        text-align: center;
        line-height: 15px;
        color: #fff;
        padding: 2px;
        min-width: 15px;
        min-height: 15px;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
.pz {
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  margin-bottom: 5px;
}
.pz {
  background-color: #4da5ff;
}
.xq {
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  margin-bottom: 5px;
  background: #4da5ff;
}

.message {
  position: absolute;
  top: 250px;
  right: 100px;
  font-size: 16px;
  color: #a77c5a;
  font-weight: bold;
}
</style>
